var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "sub-navigation",
      attrs: { app: "", dark: "", permanent: "", fixed: "", floating: "" }
    },
    [
      _vm.title
        ? [
            _c(
              "h1",
              {
                staticClass: "text-xs-center ma-3",
                staticStyle: { color: "white" }
              },
              [_vm._v(_vm._s(_vm.coTitle))]
            ),
            _vm._v(" "),
            _c("hr", {
              staticStyle: { margin: "auto" },
              attrs: { color: _vm.coColor, size: "1px", width: "50%" }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("button", { staticClass: "text-xs-center mt-3" }, [
        _c(
          "div",
          { staticClass: "mt-3 sub-navigation__lines", attrs: { inset: "" } },
          [
            _c("div", {
              staticClass: "sub-navigation__picto sub-navigation__picto--pink"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "sub-navigation__picto sub-navigation__picto--yellow"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "sub-navigation__picto sub-navigation__picto--green"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("v-flex", { staticClass: "sub-navigation__container" }, [
        _c(
          "div",
          { staticClass: "sub-navigation__scrollbar-container" },
          [
            _c(
              "v-scrollbar",
              {
                ref: "Scrollbar",
                staticStyle: { "max-height": "700px" },
                attrs: { classes: "my-scrollbar" }
              },
              [_vm._t("default")],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      !_vm.hideAddButton
        ? _c(
            "div",
            { ref: "createButtonRef", staticClass: "text-xs-center" },
            [
              _c(
                "v-tooltip",
                { attrs: { top: "" } },
                [
                  _c(
                    "template",
                    { slot: "activator" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "add-button--margin-left",
                          style: { background: _vm.coColor + " !important" },
                          attrs: {
                            color: _vm.coColor,
                            outline: "",
                            fixed: "",
                            bottom: "",
                            large: "",
                            fab: ""
                          },
                          on: { click: _vm.handleClick }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: _vm.iconColor } },
                            [_vm._v("add")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.AddButtonToolTip))])
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hideEditButton
        ? _c(
            "div",
            { ref: "createButtonRef", staticClass: "text-xs-center" },
            [
              _c(
                "v-tooltip",
                { attrs: { top: "" } },
                [
                  _c(
                    "template",
                    { slot: "activator" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "add-button--margin-left",
                          style: { background: _vm.coColor + " !important" },
                          attrs: {
                            color: _vm.coColor,
                            outline: "",
                            fixed: "",
                            bottom: "",
                            large: "",
                            fab: ""
                          },
                          on: { click: _vm.handleEditClick }
                        },
                        [
                          _c("v-icon", { attrs: { color: _vm.iconColor } }, [
                            _vm._v("edit")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.AddButtonToolTip))])
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cbb0bd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbb0bd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/sub-navigation/template.html
// module id = null
// module chunks = 